import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { SaveSurveyRulesRPC } from "./saveSurveyRulesRPC";

export class SaveSurveyRulesRPCClientImpl extends SaveSurveyRulesRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: SaveSurveyRulesRPC.Request): Promise<LeoRPCResult<SaveSurveyRulesRPC.Response, SaveSurveyRulesRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-rules/SaveSurveyRules",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      SaveSurveyRulesRPC.ResponseDTO,
      SaveSurveyRulesRPC.Errors.ErrorsDTO,
      SaveSurveyRulesRPC.Response,
      SaveSurveyRulesRPC.Errors.Errors
    >(
      response,
      "survey-rules/SaveSurveyRules",
      SaveSurveyRulesRPC.Response.fromDTO,
      SaveSurveyRulesRPC.Errors.fromDTO
    );
  }
}
